import { AxiosRequestConfig } from 'axios';
import configs from '@/root/configs';
import { request } from '@/services/utils';

export const getNextApiUrl = (endpoint: string): string => {
  if (typeof endpoint !== 'string') {
    throw new Error('endpoint must be string');
  }
  if (endpoint.trim() === '') {
    throw new Error('endpoint must not be empty string');
  }

  // * remove first and last slashes
  const formattedEndpoint = endpoint
    .split('/')
    .filter((x) => x)
    .join('/');

  return `/${configs.nextApiPrefix}/${formattedEndpoint}`;
};

export const getNextAppBaseUrl = (req: TServerSideRequest) => {
  const _protocol = req.url?.startsWith?.('https') ? 'https' : 'http';
  const { host, ['x-forwarded-proto']: protocol = _protocol } = req.headers;

  return `${protocol}://${host}`;
};

export const requestNextApi = <T = any>(
  endpoint: string,
  config: AxiosRequestConfig = {}
): Promise<T> => {
  return request({
    baseURL: window.location.origin,
    url: getNextApiUrl(endpoint),
    withCredentials: true,
    ...config,
  });
};
